import request from "@/utils/request";

// 创建支付单
export function doPay(data) {
  return request({
    method: "post",
    path: "pay/create",
    data,
  });
}

// 获取支付预览
export function getPreview(data) {
  return request({
    method: "post",
    path: "pay/preview",
    data,
  });
}

// 获取支付详情
export function getPayDetail(data) {
  return request({
    method: "post",
    path: "pay/getPayDetail",
    data,
  });
}

// 获取支付二维码
export function getPayQrcode(data) {
  return request({
    method: "post",
    path: "pay/getPayQrcode",
    data,
  });
}
